import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_ADMIN_IPP_NAV_INTROSPECT = `${URL_APP_ADMIN}/ipp-nav-introspect`
const URL_ADMIN_IPP_NAV_INTROSPECT_LIST_NAV_ENTRIES = `${URL_ADMIN_IPP_NAV_INTROSPECT}/list-nav-entries`
// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'app-admin-ipp-nav-introspect'>
  | DashRouteType<'app-admin-ipp-nav-introspect-list-nav-entries'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-ipp-nav-introspect': URL_ADMIN_IPP_NAV_INTROSPECT,
  'app-admin-ipp-nav-introspect-list-nav-entries': URL_ADMIN_IPP_NAV_INTROSPECT_LIST_NAV_ENTRIES,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
